import React from 'react';
import classnames from 'classnames';

import { Icon } from '../icon/Icon';
import styles from './Wizard.module.scss';

export interface WizardTabProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    selected: boolean;
    icon?: React.FC;
    testId?: string;
    denominator?: number;
    numerator?: number;
    showNumberFraction?: boolean;
    nonSelectedColour?: string;
}

export const WizardTab: React.FC<WizardTabProps> = ({ label = '', onClick, disabled = false, selected, icon, testId, denominator, numerator, showNumberFraction, nonSelectedColour = '' }) => (
    <div className={styles.wizardTabWrapper}>
        <button
            onClick={onClick}
            className={classnames(styles.wizardTab, {
                [styles.selectedTab]: selected
            })}
            style={{ backgroundColor: !selected ? nonSelectedColour : '' }}
            disabled={disabled}
            data-testid={`${testId}-wizard-tab-${label.toLowerCase().replace(/ +/g, '-').replace(/&/g, 'and')}`}
        >
            <div className={styles.content} data-testid={`${testId}-wizard-tab-${label.toLowerCase().replace(/ +/g, '-').replace(/&/g, 'and')}-label`}>
                {icon && <Icon icon={icon} />}
                <div style={{ marginLeft: icon ? '5px' : '0' }}>{label}</div>
            </div>
            {showNumberFraction ? <div className={styles.queryTotal}>{`${numerator} / ${denominator}`}</div> : null}
        </button>
    </div>
);
